module.exports = "<div class=\"gw-badge gw-badge_type_{{ type || 'default' }}\">\n    <div class=\"gw-badge__content\">\n        <ng-transclude></ng-transclude>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/widgets/badge/templates/Badge.html
// module id = 518
// module chunks = 0